export const emojiAttributes: any = {
    'all': 'All',
    '1f44d': 'Like',
    '2764-fe0f': 'Heart',
    '1f389': 'Celebration',
    '1f31f': 'Excellent',
    '1f973': 'Cheer',
}